import { MensajeService } from './../mensaje/mensaje.service';
import { bl } from 'app/view/impo/impo';
import { CorreoService } from './correo.service';
import { Component, OnInit, Input, Output } from '@angular/core';

declare var $: any;

@Component({
    moduleId: module.id,
    selector: 'enviar-correo',
    templateUrl: './correo.component.html'
})

export class CorreoComponent implements OnInit {

    @Input() codigo: string = "";
    @Input() fecha: string = "";

    @Input() ruc: string = "";
    @Input() razon: string = "";
    @Input() monto: string = "";

    @Input() moneda: string = "";

    constructor(private correo: CorreoService, private sms: MensajeService) {
    }

    compartiendo = false;

    compartir_voucher(email) {
        var html_voucher = `<!DOCTYPE html><html><head></head><body><div class="row"><div class="card" style="text-align: center ;display: -ms-flexbox;display: flex;-ms-flex-direction: column;flex-direction: column;background-color: #fff;border: 2px solid #004165;border-radius: 0.25rem; width: 500px"><div class="card-block p-2"><div class="row" style="text-align: center !important;"><br><div><h3 style="color: #004165;margin: 0 0 !important;">APM TERMINALS</h3><small style="color: #A7ADB1;">APM Terminals Inland Services</small><br></div><br><div><h3 style="color: #004165;margin: 0 0 !important;">` + this.codigo + `</h3><small style="color: #A7ADB1;">Código de Pago</small></div><br><div style="flex: 0 0 25%; text-align: center !important;"><h3 style="color: #004165;margin: 0 0 !important;">` + this.convertir_fecha(this.fecha) + `</h3><small style="color: #A7ADB1;">Fecha de Liquidación</small></div><br><div style="flex: 0 0 25%; text-align: center !important;"><h3 style="color: #004165;margin: 0 0 !important;">` + this.ruc + ` - ` + this.razon + `</h3><small style="color: #A7ADB1;">Cliente a Facturar</small></div><br><div style="flex: 0 0 25%; text-align: center !important;"><h3 style="color: #004165;margin: 0 0 !important;">` + this.moneda + " " + this.monto + `</h3><small style="color: #A7ADB1;">Total a pagar</small></div><br></div></div></div></div></body></html>`;
        var html_arv = "";
        this.compartiendo = true;
        this.correo.enviar_voucher(email, html_voucher, this.codigo)
            .subscribe(resp => {
                this.sms.enviarAlerta({ mensaje: resp.mensaje, tipo: 1 })
                $('#enviar-correo').modal('hide');
                this.compartiendo = false;
            }, error => console.log(error))
    }

    convertir_fecha(date: string) {
        var fecha = date.split(" ")[0];
        var hour = date.split(" ")[1];
        return fecha.split("-")[2] + "/" + fecha.split("-")[1] + "/" + fecha.split("-")[0] + " " + hour.split(":")[0] + ":" + hour.split(":")[1];
    }

    ngOnInit() {
        this.compartiendo = false;
    }
}


// WEBPACK FOOTER //
// C:/carlos/wks/web/vacios_web/src/app/modulo_compartido/correo/correo.component.ts